import { render, staticRenderFns } from "./reviewLog.vue?vue&type=template&id=9524cfe2&scoped=true"
import script from "./reviewLog.vue?vue&type=script&lang=js"
export * from "./reviewLog.vue?vue&type=script&lang=js"
import style0 from "./reviewLog.vue?vue&type=style&index=0&id=9524cfe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9524cfe2",
  null
  
)

export default component.exports